import { EventTypes } from '~analytics/types';

import { sendBulkAddQuestionsEvent } from '../index';
import { EventAdapter } from './EventAdapter';

interface BulkAddQuestionsEventAdapterParams {
  numQuestions: number;
  numMultipleChoiceQuestions: number;
  numTrueFalseQuestions: number;
  numShortAnswerQuestions: number;
  uiSource?: 'ai_import';
}

export class BulkAddQuestionsEventAdapter extends EventAdapter {
  protected amplitudeEventFunction = sendBulkAddQuestionsEvent;
  protected intercomEventKey = EventTypes.BulkAddQuestions;
  constructor({
    numQuestions,
    numMultipleChoiceQuestions,
    numTrueFalseQuestions,
    numShortAnswerQuestions,
    uiSource,
  }: BulkAddQuestionsEventAdapterParams) {
    super();

    try {
      this.eventData = {
        num_questions: numQuestions,
        num_questions_multiple_choice: numMultipleChoiceQuestions,
        num_questions_true_false: numTrueFalseQuestions,
        num_questions_short_answer: numShortAnswerQuestions,
        ui_source: uiSource,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
